///** 
// * Link multiple element by their state (value, class, etc.)
// *
// * Manage value for form element (input:checkbox, custom element)
// */
(function ($, app) {
    'use strict';

    app.LinkedElement = function ($elemList) {
        if ($elemList.length <= 1) {
            return;
        }

        var idList = $elemList.map(function (e) { return '#' + e.attr('id'); });

        for (var i = 0; i < $elemList.length; i++) {
            var $elem = $elemList[i];

            $elem
                .on('lnkElem.update', function (e) {
                    var $this = $(this);
                    var $tmpList = $(idList.filter(function (e) { return '#' + $this.attr('id') !== e; }).join(', '));

                    UpdateElement(
                        $this
                        , $tmpList
                    );

                    $this.trigger('lnkElem.updated');
                    $tmpList.trigger('lnkElem.updated');
                });
        }

        function UpdateElement($elem, $targets) {
            if ($elem.is('.lkelem-custom:not(.lkelem-custom-item)')) {
                $targets = $targets.find('.lkelem-custom-item');
                $elem = $elem.find('.lkelem-custom-item');
            }

            $elem.each(function () {
                var $this = $(this);
                var action = $this.data('lkelem-action');

                if (action === 'class') {
                    UpdateElementClass($this, $targets);
                }
                else {
                    UpdateElementValue($this, $targets);
                }                
            });            
        }

        function UpdateElementValue($elem, $target) {
            if ($elem.is('input:checkbox')) {
                var selector = $elem.is(':checked') ? ':not(:checked)' : ':checked';
                $target.filter(selector).trigger({
                    type: 'click',
                    echo: true
                });
            }
            else {
                $target.val($elem.val());
            }
        }

        function UpdateElementClass($elem, $target) {
            if ($elem.is('.lkelem-custom-item') && $elem.data('lkelem-key')) {
                $target.filter('.lkelem-custom-item[data-lkelem-key=' + $elem.data('lkelem-key') + ']')
                    .attr('class', $elem.attr('class'));
            }
            else {
                $target.attr('class', $elem.attr('class'));
            }
        }
    };

    $.fn.LinkedElement = function () {
        var args = Array.prototype.slice.call(arguments);
        args.push(this);
        app.LinkedElement(args);
        return this;
    };
})(jQuery, window.app = window.app || {});
